import {Authentication, authenticationDecoder} from './Authentication'
import {Cis2User, cis2UserDecoder} from '../Entities/Cis2User'
import {Manufacturer, manufacturerDecoder} from '../Entities/Manufacturer.entity.evolve'
import {array, Decoder, field, object} from 'json-bouncer'

export interface IntermediateSession {
    readonly authentication: Authentication
    readonly cis2User: Cis2User
    readonly manufacturers: Manufacturer[]
}

export function intermediateSessionDecoder(): Decoder<IntermediateSession> {
    return object({
        authentication: field('authentication', authenticationDecoder()),
        cis2User: field('cis2User', cis2UserDecoder()),
        manufacturers: field('manufacturers', array(manufacturerDecoder())),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/IntermediateSession.ts